<template>
  <div>
    <right-panel :datas="connects" :items="connects" @onClose="onCloseForm" @onSubmit="onSubmitForm" ref="right-panel">
      <div slot="header">
        <translate>Create Group</translate>
      </div>
    </right-panel>
  </div>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  export default{
    name: 'TeamAddGroup',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        connects: null
      }
    },
    methods: {
      // 确定创建群组
      onSubmitForm () {
        let params = {
          data: Object.assign({}, this.$refs['right-panel'].profileModel)
        }
        console.log('par', params)
        this.$store.dispatch(STORE_CONST.TEAM.ADD_GROUP, params).then(() => {
          this.$notify({
            type: 'success',
            message: this.$gettext('Create group successfully!')
          })
          this.$emit('callback')
          this.$refs['right-panel'].onClose()
        }).catch(err => {
          console.log('err', err)
          this.$refs['right-panel'].onSubmitErr()
        })
      },
      // 关闭创建群组
      onCloseForm () {
        this.connects = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
            }, 300)
          } else {
            this.connects = this.items
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">

</style>



// WEBPACK FOOTER //
// team-add-group.vue?0f16dc25